export const PLAN_RANK = { free: 0, pro: 1, press_box_pro: 2 };
export const PLAN_NAMES = { free: "Free Fan", pro: "Pro Fan", press_box_pro: "Press Box Pro" };
export const PLAN_PRICES = { pro: "$9.99/mo", press_box_pro: "$299/mo" };
export const UPGRADE_EVENT = "gamly:upgrade";

export const hasPlan = (user, minPlan) => (PLAN_RANK[user?.plan || "free"] ?? 0) >= PLAN_RANK[minPlan];

export const openUpgrade = (detail) => window.dispatchEvent(new CustomEvent(UPGRADE_EVENT, { detail }));
